export const OLD_VERSION_MODE_ON = 'OLD_VERSION_MODE_ON';
export const OLD_VERSION_MODE_OFF = 'OLD_VERSION_MODE_OFF';
export const MODAL_OLD_VERSION_MODE_CLOSE = 'MODAL_OLD_VERSION_MODE_CLOSE';
export const MODAL_OLD_VERSION_MODE_OPEN = 'MODAL_OLD_VERSION_MODE_OPEN';

export const HANDLE_OLD_VERSION_MODE = '@oldVersion/HANDLE_OLD_VERSION_MODE';
